import { AppLayout, Main } from './Panel.style';
import { Topbar } from './layout/Topbar/Topbar';
import { Footer } from '@layouts/Footer/Footer';

export function Panel({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <Topbar />
      <Main>{children}</Main>
      <Footer />
    </AppLayout>
  );
}
